import React from "react";
import {Select} from "antd";
import BaseComponent from "../../../../redare/components/BaseComponent";
import PlatformPresenter from "../../.gen/presenter/component/core/PlatformPresenter";

export default class PlatformMenuSelect extends BaseComponent {

    static defaultProps = {
        initFirstValue: false,
        allowClear: true,
        platform: undefined,
        onValueChange: undefined,
        style: undefined
    };

    constructor(props) {
        super(props);
        this.state = {data: [], value: this.props.value};
        this.presenter = new PlatformPresenter(this);
        this._form.platform = this.props.platform;
    }

    UNSAFE_componentWillReceiveProps({platform, value}, nextContext) {
        if (platform !== this.props.platform) {
            this.setPlatform(platform);
        }
        if (this.props.value !== value) {
            this._onValueChange(value);
        }
    }

    componentDidMount() {
        if (this._form.platform) {
            this._findMenuList();
        }
    }

    setPlatform(platform, unClearValue) {
        if (!unClearValue && this._form.platform !== platform) {
            this._onValueChange();
        }
        this._form.platform = platform;
        if (this._form.platform) {
            this._findMenuList();
        } else {
            this.setState({data: []});
        }
    }

    setValue(value) {
        this._onValueChange(value);
    }

    _findMenuList() {
        let {platform} = this._form;
        this.presenter.findMenuList({platform}, {returnAll: true}, (result) => {
            if (this.props.initFirstValue) {
                let data = result.data;
                if (data.length > 0) {
                    this._onValueChange(data[0].id);
                }
            }
            this.setState({
                data: result.data
            })
        });
    }

    _onValueChange(value) {
        this.setState({value});
        if (this.props.onValueChange) {
            this.props.onValueChange(value);
        }
    }

    renderOption() {
        let options = [];
        this.state.data.forEach((v) => {
            options.push(
                <Select.Option key={v.id} value={v.id}>{v.name}</Select.Option>
            )
        });
        return options;
    }

    render() {
        return (
            <Select allowClear={this.props.allowClear} value={this.state.value}
                    onChange={this._onValueChange.bind(this)}
                    style={this.props.style}>
                {
                    this.renderOption()
                }
            </Select>
        )
    }
}
